module.exports = __webpack_public_path__ + "static/img/faceRecognition.ddec872.svg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/faceRecognition.svg
// module id = 2w5G
// module chunks = 1